import React from 'react'
import PropTypes from 'prop-types'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import styles from './styles/PreviewButton'

const PreviewButton = ({ isEmail, toggle }) => (
  <FloatingActionButton
    mini
    style={isEmail ? styles.previewButtonEmail : styles.previewButtonText}
    onTouchTap={toggle}
    backgroundColor={'#0084ff'}
  >
    <div style={styles.img}>
      <img src="/images/eye.svg" alt="preview" />
    </div>
  </FloatingActionButton>
)

PreviewButton.propTypes = {
  toggle: PropTypes.func.isRequired,
  isEmail: PropTypes.bool.isRequired,
}

export default PreviewButton



// WEBPACK FOOTER //
// ./src/components/Messages/PreviewButton.js